import React from 'react'
import {
    Box,
    ListItem
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import './announcement-bar.scss'
import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {options} from '../../../rich-text/Options'
import {CloseIcon} from '@salesforce/retail-react-app/app/components/icons'

const AnnouncementBarSlide = ({sys, text, theme, onClose}) => {
    const itemStyling = {
        color: theme?.color || 'black',
        fontSize: {
            base: '16px',
            md: '14px'
        },
        fontWeight: {
            base: '400',
            md: '500'
        },
        whiteSpace: 'unset',
        wordBreak: 'break-word',
        lineHeight: '1.4',
        textAlign: 'center',
        padding: 'none',
        height: '100%'
    }

    return (
        <ListItem
            padding={{base: '0', md: '12px 18px'}}
            key={sys.id}
            width="100vw"
            maxWidth="100vw"
            minHeight="30px"
            backgroundColor={theme?.backgroundColor || '#F1F0EF'}
            textAlign="center"
            display="flex"
            justifyContent="center"
            {...itemStyling}
        >
            <>
                {documentToReactComponents(
                    text,
                    options({
                        entries: {inline: []},
                        assets: {block: []}
                    })
                )}
            </>
            <CloseIcon onClick={() => onClose(sys?.id)} />
        </ListItem>
    )
}

AnnouncementBarSlide.propTypes = {
    sys: PropTypes.shape({
        id: PropTypes.string
    }),
    text: PropTypes.object,
    onClose: PropTypes.func,
    theme: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string
    })
}

AnnouncementBarSlide.displayName = 'AnnouncementBarSlide'

export default AnnouncementBarSlide
